import { useEffect } from 'react';
import { useQueryParams, StringParam, ArrayParam } from 'use-query-params';
import { useDispatch, useSelector } from 'react-redux';
import { AppDispatch, RootState } from 'store/configureStore';
import { globalOp } from 'store/ducks/Global';
import { IFilters } from 'store/ducks/globalTypes';
import { set_isSoftDeleted } from 'store/ducks/DataEntry/Entities/entitySlice';

const useFilters = () => {
  const dispatch: AppDispatch = useDispatch();
  const [query, setQuery] = useQueryParams({
    entity: StringParam,
    entityId: StringParam,
  });
  const [queryLei, setQueryLei] = useQueryParams({
    entity: StringParam,
    entityId: ArrayParam,
  });
  const { isSoftDeleted } = useSelector((state: RootState) => state.entities);
  const filtersData = useSelector(
    (state: RootState) => state.global.filtersData as IFilters[],
  );

  const handleFilterChange = (value: string, id: number | string) => {
    setQuery((latestQuery) => {
      const entityIdValue = id
        ? typeof id === 'number'
          ? id.toString()
          : id
        : undefined;
      const newQuery = {
        ...latestQuery,
        entity: value || undefined,
        entityId: entityIdValue,
      };
      return newQuery;
    });
  };

  const handleFilterChangeForReportingsLei = (
    values: number | number[],
    labels: string | string[],
  ) => {
    const valueArray = Array.isArray(values) ? values : [values];
    const labelArray = Array.isArray(labels) ? labels : [labels];

    const entityName = labelArray.join(', ');
    setQueryLei((latestQuery) => ({
      ...latestQuery,
      entityId: valueArray.map((v) => v.toString()),
    }));
  };

  const handleFilterChangeForReportings = (
    value: string,
    id: number | string,
  ) => {
    setQuery((latestQuery) => {
      const newQuery = {
        ...latestQuery,
        entity_name: value,
        entityId: id.toString(),
      };
      return newQuery;
    });
  };

  const extractedOptions = filtersData.flatMap((item) => {
    if (Array.isArray(item.options)) {
      return item.options.map((option) => {
        const mappedOption = {
          label: option.name_of_entity,
          value: option.value,
          key: option.id,
        };

        return mappedOption;
      });
    }
    return [];
  });

  useEffect(() => {
    if (isSoftDeleted) {
      dispatch(globalOp.setFilters());
      dispatch(set_isSoftDeleted(false));
    }
  }, [isSoftDeleted]);

  useEffect(() => {
    dispatch(globalOp.setFilters());
  }, [dispatch]);

  return {
    query,
    queryLei,
    handleFilterChange,
    extractedOptions,
    handleFilterChangeForReportings,
    handleFilterChangeForReportingsLei,
  };
};

export default useFilters;
